import { getSetup } from './getSetup';

export function normalize(u?: string | null): string {
	return (u || '').trim().replace(/\/+$/, '');
}

export function unquote(s?: string | null): string {
	const t = (s || '').trim();
	if (
		(t.startsWith('"') && t.endsWith('"')) ||
		(t.startsWith("'") && t.endsWith("'"))
	)
		return t.slice(1, -1);
	return t;
}

export function stripKnownModule(base: string): string {
	return base.replace(/\/module\/(delivery|vitals)\/bpca$/i, '');
}

export function ensurePathOnce(base: string, needed: string): string {
	const b = normalize(base);
	if (!b) return '';
	return b.includes(needed) ? b : `${b}${needed}`;
}

export function pickVitalsBase(setup: any): { base: string; picked: string[] } {
	const useQs =
		setup?.use_qs === 'true' || localStorage.getItem('use_qs') === 'true';

	const candidatesQS = setup?.market?.qsUrl || localStorage.getItem('qs_url');
	const candidatesVitals = setup?.market?.urls?.vitals;
	const generic =
		setup?.market?.urls?.delivery || localStorage.getItem('url_vitals');

	const picked: string[] = [];
	const tryBuild = (raw?: string | null) => {
		const cleaned = normalize(unquote(raw || ''));
		if (!cleaned) return '';
		const base = stripKnownModule(cleaned);
		return ensurePathOnce(base, '/module/vitals/bpca');
	};

	const sources = useQs
		? [candidatesQS, generic, candidatesVitals]
		: [candidatesVitals, generic, candidatesQS];

	for (const src of sources) {
		const b = tryBuild(src);
		if (b) {
			picked.push(String(src));
			return { base: b, picked };
		}
	}

	return { base: '', picked };
}

export function sendHeartbeat() {
	const setup = getSetup();
	if (!setup) return;

	const payload = {
		brand: setup.brand,
		market: setup.market?.name,
		kvps: localStorage.getItem('kvps'),
		version: localStorage.version,
		device: setup.device,
		clientId: setup.clientId,
	};

	if (navigator.onLine) {
		fetch('https://heartbeat.did.b12-ssp.de/api/heartbeat', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(payload),
		}).catch(err => {
			console.warn('Heartbeat failed', err);
		});
	}
}

export function sendVitalsHeartbeat() {
	const setup = getSetup();
	if (!setup || !setup.device) {
		console.warn('[VitalsHeartbeat] missing setup/device');
		return;
	}

	const { base, picked } = pickVitalsBase(setup);
	console.log('[VitalsHeartbeat] resolve', {
		use_qs_setup: setup?.use_qs,
		use_qs_ls: localStorage.getItem('use_qs'),
		candidatesChosen: picked,
		resolvedBase: base,
	});

	if (!base) {
		console.warn('[VitalsHeartbeat] no vitals base URL resolved');
		return;
	}

	const url = `${base}/vitals/heartbeat/${encodeURIComponent(setup.device)}`;
	console.log('[VitalsHeartbeat] POST', url);

	if (navigator.onLine) {
		fetch(url, {
			method: 'POST',
			cache: 'no-store',
			credentials: 'omit',
		})
			.then(resp => {
				if (!resp.ok) {
					console.warn('[VitalsHeartbeat] non-OK', {
						status: resp.status,
						url,
					});
				}
			})
			.catch(err => {
				console.warn('[VitalsHeartbeat] network error', err);
			});
	}
}
